import React, { PropTypes } from 'react';
import FloatingActionButton from 'material-ui/FloatingActionButton'
import SvgIconContentAdd from 'material-ui/svg-icons/content/add';
import SvgIconNavigationClose from 'material-ui/svg-icons/navigation/close';

class SpeedDial extends React.Component {
  static propTypes = {
    style: PropTypes.object,
    open: PropTypes.bool.isRequired,
    direction: PropTypes.oneOf(['down', 'up']).isRequired,
    onClick: PropTypes.func,
    openIcon: PropTypes.node.isRequired,
    closeIcon: PropTypes.node.isRequired,
    children: PropTypes.node
  };

  static contextTypes = {
    muiTheme: PropTypes.object.isRequired
  };

  getItemStyles() {
    let { direction, open } = this.props;
    return {
      position: 'absolute',
      top: direction === 'down' ? 61 : null,
      bottom: direction === 'up' ? 61 : null,
      right: 0,
      height: open ? 'auto' : 0,
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end'
    };
  }

  render() {
    let {
      style,
      openIcon,
      closeIcon,
      children,
      onClick,
      open
    } = this.props;

    const {
      baseTheme: {palette: { primary1Color, disabledColor }}
    } = this.context.muiTheme;

    return (
      <div style={Object.assign({position: 'relative'}, style)}>
        <FloatingActionButton onClick={onClick} backgroundColor={open ? disabledColor : primary1Color}>
          {open ? closeIcon : openIcon}
        </FloatingActionButton>
        <div style={this.getItemStyles()}>
          {children}
        </div>
      </div>
    );
  }
}

SpeedDial.defaultProps = {
  style: {},
  direction: 'down',
  openIcon: <SvgIconContentAdd color="white"/>,
  closeIcon: <SvgIconNavigationClose color="white"/>
};

export default SpeedDial;




// WEBPACK FOOTER //
// ./src/components/SpeedDial/SpeedDial.js